import React from 'react';
import { formatHours } from '../../../utils/grafikHelpers';

/**
 * Lewa kolumna - lista pracownikow z sumami godzin.
 * Props:
 *   users:[{login, typ, suma_godzin, ma_konflikty?, ma_niezaakceptowane?}]
 *   summary: {[login]: {planowane?, zatwierdzone?, urlop?, ...}}
 *   selectedUserLogin
 *   onSelect(login)
 *   loading
 */
const EmployeeList = ({ users = [], summary = {}, selectedUserLogin, onSelect, loading }) => {
  return (
    <div style={{
      width: '280px',
      minWidth: '280px',
      borderRight: '1px solid var(--border)',
      backgroundColor: 'var(--card-bg)',
      maxHeight: '70vh',
      overflowY: 'auto'
    }}>
      <div style={{
        padding: '0.75rem 1rem',
        borderBottom: '1px solid var(--border)',
        backgroundColor: 'var(--bg)',
        fontSize: '0.85rem',
        fontWeight: 600,
        color: 'var(--text-secondary)'
      }}>
        <i className="fas fa-users" style={{ marginRight: '0.5rem' }} />
        Pracownicy ({users.length})
      </div>

      {loading && (
        <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          Ladowanie...
        </div>
      )}

      {!loading && users.length === 0 && (
        <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          Brak pracownikow w tej lokalizacji
        </div>
      )}

      {users.map(u => {
        const isSelected = selectedUserLogin === u.login;
        const userSummary = summary[u.login] || {};
        const totalHours = u.suma_godzin ?? userSummary.suma_godzin ?? userSummary.planowane ?? 0;
        const hasWarning = u.ma_niezaakceptowane || u.ma_konflikty;
        return (
          <div
            key={u.login}
            onClick={() => onSelect(u.login)}
            style={{
              padding: '0.75rem 1rem',
              borderBottom: '1px solid var(--border)',
              cursor: 'pointer',
              backgroundColor: isSelected ? 'var(--info-light)' : 'transparent',
              borderLeft: isSelected ? '3px solid var(--info)' : '3px solid transparent',
              transition: 'background-color 0.1s'
            }}
            onMouseOver={(e) => {
              if (!isSelected) e.currentTarget.style.backgroundColor = 'var(--bg)';
            }}
            onMouseOut={(e) => {
              if (!isSelected) e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', minWidth: 0 }}>
                {hasWarning && (
                  <span title="Sa konflikty lub niezaakceptowane zmiany"
                    style={{
                      width: '8px', height: '8px', borderRadius: '50%',
                      backgroundColor: 'var(--warning)',
                      flexShrink: 0, display: 'inline-block'
                    }}
                  />
                )}
                <span style={{
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  color: 'var(--text)',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {u.login}
                </span>
              </div>
            </div>
            <div style={{
              display: 'flex', justifyContent: 'space-between',
              fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.25rem'
            }}>
              <span>{u.typ || 'pracownik'}</span>
              <span style={{ fontWeight: 600, color: 'var(--info)' }}>{formatHours(totalHours)}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EmployeeList;
